import type { Theme } from '@mui/material';

export const styles = {
  chip: (theme: Theme) => ({
    maxWidth: 250,
    '&.Mui-disabled': { border: `1px solid ${theme.colors.neutral[500]}` },
  }),
  showMoreButton: (theme: Theme) => ({
    color: theme.colors.neutral[600],
    fontWeight: 600,
    fontSize: '0.875rem',
    alignSelf: 'end',
  }),
};
